var cookies = function(){
    /**
     * Create cookie
     * @param name
     * @param value
     * @param days
     */
    function create(name,value,days){
        var expires = "";
        if(days){
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    }

    /**
     * Read cookie
     * @param name
     */
    function read(name){
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    /**
     * Delete cookie
     * @param name
     */
    function erase(name){
        create(name, "", -1);
    }

    return {
        "create":create,
        "read":read,
        "erase":erase
    };
}();